<style lang="scss" scoped="home">
  @import "./style.scss"
</style>

<template>
    <div class="home"  v-if="$store.state.isPc">
    	<div class="carousel-item" >
	    			<div class="banner">
	    			</div>
		    		<div class="company-introduct">
				    	<div class="div-item">
								<h1>企业简介</h1>
								<span class="detail">COMPANY PROFILE</span>
							</div>
							<div class="border div-item">
								<p> 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。</p>
							</div>
							<div class="border div-item">
								<p >亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。
								</p>
							</div>
						</div>
		    		<div class="company-profile">
				    	<div class="div-item">
								<h1>企业文化</h1>
								<span class="detail">COMPANY PROFILE</span>
							</div>
							<div class="profile">
								<div class="width-30 hezuo">
									<img class="hezuo" src="../../../assets/home/hezuo.jpg" />
								</div>
								<div class="width-70">
									<div class="border div-item">
										<p> 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。</p>
									</div>
									<div class="border div-item">
										<p >快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。
										</p>
									</div>
									<div class="border div-item">
										<p >目标明确，坚定不移，天道酬勤，永续经营。
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
    </div>
    <div class="home"  v-else>
    	<div class="carousel-item" >
	    			<div class="banner">
	    			</div>
		    		<div class="company-introduct">
				    	<div class="div-item">
								<h1>企业简介</h1>
								<span class="detail">COMPANY PROFILE</span>
							</div>
							<div class="border div-item">
								<p> 苏州亿数腾云科技有限公司团队成立于2008年，由一批专注于软件和硬件系统集成的行业精英组成。十多年的开发经验，奠定了强大的技术实力。于2018年正式成立科技公司，公司延续了强大的开发能力，并且将优势定位于企业管理类，工业流程类，大数据分析，物联网应用等解决方案。崭新的解决方案已经给数十家客户带来福音。</p>
							</div>
							<div class="border div-item">
								<p >亿数人秉承不断进取，勇于创新理念，以客户需求为出发点，实实在在的服务好客户。已经在各行各业获得了客户一致好评。
								</p>
							</div>
						</div>
		    		<div class="company-profile">
				    	<div class="div-item">
								<h1>企业文化</h1>
								<span class="detail">COMPANY PROFILE</span>
							</div>
							<div class="profile">
									<div class="border div-item">
										<p> 成功靠朋友，成长靠对手，成就靠团队。创意是金钱，策划显业绩，思考才致富。知道是知识，做到才智慧，多做少多说。积极激励我，多劳多收获，汗水育成果。梦想聚团队，团队铸梦想，激情快乐人。</p>
									</div>
									<div class="border div-item">
										<p >快乐让公司环境变得令人愉快点吧。当人们喜欢他们所做的工作，并且乐于与那些一起工作的人共事，他们就会高效率地工作。
										</p>
									</div>
									<div class="border div-item">
										<p >目标明确，坚定不移，天道酬勤，永续经营。
										</p>
								</div>
							</div>
						</div>
					</div>
    	</div>
</template>

<script>
import script from './script.js'
export default script
</script>



// WEBPACK FOOTER //
// src/views/custom/home/index.vue